import { RFP_IS_DISCLOSE } from '@/utils/constants/rfp/isDisclose';
import { RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED } from '@/utils/constants/rfp/professional/dataType';
/**
 * 案件依頼元の組織名を返す
 * @param options
 */
export const getClientOrganizationName = (options) => {
    const { altText = '企業名非開示', clientOrganizationName = '', dataType, isDisclose, } = options;
    // 閲覧申請未承認の場合、非開示用の文言を表示する
    if (dataType === RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED.value) {
        return isDisclose === RFP_IS_DISCLOSE.value ? altText : '企業名公開';
    }
    // 承認済の場合、企業名か固定文言を表示する
    return clientOrganizationName || altText;
};
